"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertContext = void 0;
var react_1 = require("react");
var AlertManagerContext_1 = require("../../modules/Common/Alert/AlertManagerContext");
/**
 * Custom hook to access AlertManagerContext. This way is easier to call
 * on tests, but actually simplifies the context use everywhere
 */
var useAlertContext = function () { return (0, react_1.useContext)(AlertManagerContext_1.AlertManagerContext); };
exports.useAlertContext = useAlertContext;
